import { getRequest } from "./https-axios.service";
import { getRuntimeEnv } from "./runtime-config";

const API_BASE_URL = getRuntimeEnv("REACT_APP_NEST_API_URL");
if (!API_BASE_URL) {
  throw new Error("REACT_APP_NEST_API_URL is not defined");
}
const BASE_URL = `${API_BASE_URL.replace(/\/$/, "")}/tasks`;

export interface OpenTask {
  id: number;
  createdDateTime: string;
  taskStatus: {
    statusName: string;
    statusColor?: string;
  };
}

interface OpenTasksResponse {
  ok: boolean;
  tasks: OpenTask[];
}

async function getOpenTasks(haatBussID: string): Promise<OpenTask[]> {
  try {
    const { data } = await getRequest<OpenTasksResponse>(
      `${BASE_URL}/open/${haatBussID}`,
    );
    return data?.ok && Array.isArray(data.tasks) ? data.tasks : [];
  } catch {
    return [];
  }
}

export const tasksApiService = { getOpenTasks };
